import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaPopover from './VaPopover.vue'

export default withConfigTransport(VaPopover)
